import { channelServices } from '~publish/helpers/channels'
import type { Channel, Service } from '~publish/gql/graphql'

import type { ChannelType } from '../../../pages/Comments/types'

export function filterChannels(
  channels: Channel[],
  searchQuery: string | null | undefined,
): Channel[] {
  if (!searchQuery || searchQuery.trim() === '') return channels

  return channels.filter(
    (channel) =>
      channel.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      channel.service.toLowerCase().includes(searchQuery.toLowerCase()),
  )
}

export const getChannelSuggestions = (
  channels: Channel[],
): Service[] | null => {
  if (channels.length > 3) return null

  const connectedChannelServices = channels.map((channel) => channel.service)

  return channelServices.filter(
    (service) => !connectedChannelServices.includes(service),
  )
}

const productPorts = {
  publish: ':8888',
  analyze: ':8081',
  engage: ':8081',
  create: ':8888',
  comments: ':8888',
  'start-page': ':9999',
  // If no port is specified, we assume the product is running on port 8080
}

export const getEngageUrl = (channelId: string): string => {
  const [, ...domainParts] = window.location.hostname.split('.')
  const domain = domainParts.join('.')
  const port = process.env.NODE_ENV === 'development' ? productPorts.engage : ''

  return `https://engage.${domain}${port}/${channelId}`
}

export function requiresRefreshing(channel: ChannelType): boolean {
  /* @TODO: Do more general this method when we add more services */
  return (
    channel.service === 'threads' &&
    (!channel.scopes?.includes('threads_read_replies') ||
      !channel.scopes?.includes('threads_manage_replies'))
  )
}
export function getTooltipContent(service: string, type: string): string {
  if (service === 'facebook' && type === 'group') {
    return 'Facebook Groups are not available for Community yet.'
  }

  if (service === 'instagram' && type === 'profile') {
    return 'Instagram Personal Profiles are not available for Community yet.'
  }

  return 'This channel is not available for Community yet.'
}
